import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { AbstractDynamicForm, FormControlWrapper, FormGroupWrapper } from '../../../dynamic-form-abstract';
import { DynamicFormDto } from '../../../../../service/dto';
import { HttpDynamicService } from '../../../../../service/http-dynamic.service';

@Component({
	selector: 'app-dynamic-form-input-sub-dynamic',
	standalone: false,
	templateUrl: './dynamic-form-input-sub-dynamic.component.html',
	styleUrl: './dynamic-form-input-sub-dynamic.component.scss'
})
export class DynamicFormInputSubDynamicComponent extends AbstractDynamicForm implements OnInit {
	@Input() wrapper!: FormControlWrapper;
	@Input() form!: FormGroup;
	@Input() dynamicForm!: DynamicFormDto;
	@Input() template!: 'card' | 'table';
	@Input() readonly = false;

	toControlKey = AbstractDynamicForm.toControlKey;
	columns: string[] = [];

	constructor(httpService: HttpDynamicService, private fb: FormBuilder, changeDetector: ChangeDetectorRef) {
		super(httpService, fb, changeDetector);
	}
	ngOnInit(): void {
		if (!this.form.contains(this.wrapper.element.property)) {
			this.form.setControl(this.wrapper.element.property, this.fb.array(this.wrapper.groups.map(item => this.fb.group(item.formControls))));
		}
		const dynamicFormDto: DynamicFormDto = this.dynamicForm.subForms[this.wrapper.element.subEntityType as string];
		this.columns = dynamicFormDto.elements
			.sort((a, b) => a.orderIndex! - b.orderIndex!)
			.map(item => item.name);
	}
	isReadOnly(formGroup: FormGroupWrapper, formControl: FormControlWrapper){
		if(this.readonly){
			return true;
		}
		if(formControl.element.activeOnCreate == true && formControl.element.activeOnUpdate == true){
			return false;
		}
		if(formControl.element.activeOnCreate == false && formControl.element.activeOnUpdate == false){
			return true;
		}

		if(!formGroup.instanceId || formGroup.instanceId <= 0){
			return formControl.element.activeOnCreate == false;
		}

		if(formGroup.instanceId && formGroup.instanceId > 0){
			return formControl.element.activeOnUpdate == false;
		}
		return true;
	}
	add() {
		const dynamicFormDto: DynamicFormDto = this.dynamicForm.subForms[this.wrapper.element.subEntityType as string];

		const group = new FormGroupWrapper();
		group.instanceId = undefined;
		group.formControls = dynamicFormDto.elements
			.sort((a, b) => a.orderIndex! - b.orderIndex!)
			.map(item => this.buildFormControlWrapper(item, dynamicFormDto));
		group.formGroup = this.fb.group({});
		group.formControls.forEach(item => group.formGroup.addControl(AbstractDynamicForm.toControlKey(item.element), item.control));
		this.wrapper.groups.push(group);

		const formArray = this.form.get(this.wrapper.element.property) as FormArray;
		formArray.push(group.formGroup);
	}
	remove(item: FormGroupWrapper) {
		const index = this.wrapper.groups.indexOf(item);
		if (index > -1) {
			this.wrapper.groups.splice(index, 1);

			const formArray = this.form.get(this.wrapper.element.property) as FormArray;
			formArray.removeAt(index);
		}
	}
}
